export const data = {
  localContext: [
    {
      subCategory:
        "Historical, geographical, socio-economic and demographic data",
      subCat: "A",
      romanNum: "I",
      overArching:
        "What are the main historical, geographical, socio-economic and demographic characteristics of the local unit that are important for understanding the state of democracy?",
      questions: [
        {
          Question:
            "What are the most important historical events that have shaped the local unit?",
          QuestionID: 1,
          subCat: "A",
        },
        {
          Question:
            "What are the key geographical features and boundaries of the local unit?",
          QuestionID: 2,
          subCat: "A",
        },
        {
          Question:
            "Are there any special territorial arrangements in place and, if so, how do these relate to indigenous or minority groups’ self-rule?",
          QuestionID: 3,
          subCat: "A",
        },
        {
          Question:
            "On what resources or endeavours is the local economy based and who owns/oversees these?",
          QuestionID: 4,
          subCat: "A",
        },
        {
          Question:
            "To what extent does the existence and/or lack of natural resources affect the local unit?",
          QuestionID: 5,
          subCat: "A",
        },
        {
          Question:
            "To what extent does the local unit experience negative environmental and socio-economic impacts due to climate change?",
          QuestionID: 6,
          subCat: "A",
        },
        {
          Question:
            "What social divisions and strata are created by local economic conditions?",
          QuestionID: 7,
          subCat: "A",
        },
        {
          Question:
            "Are there any cultural, religious, ethnic or linguistic groups of citizens that can be distinguished?",
          QuestionID: 8,
          subCat: "A",
        },
        {
          Question:
            "To what extent is there a presence of migrant populations in the local unit?",
          QuestionID: 9,
          subCat: "A",
        },
        {
          Question:
            "What is the demographic composition of the local unit in terms of sex and age?",
          QuestionID: 10,
          subCat: "A",
        },
        {
          Question:
            "How much consensus is there on the historical development, geographical boundaries and/or socio-economic and demographic arrangements of the local unit among different groups in society?",
          QuestionID: 11,
          subCat: "A",
        },
      ],
    },
    {
      subCategory: "Local government's role and influence",
      subCat: "B",
      romanNum: "II",
      overArching:
        "What is the local government’s role and influence within the country’s institutional framework?",
      questions: [
        {
          Question:
            "How could one describe the institutional structures and relations between the national, regional/provincial, and local levels?",
          QuestionID: 1,
          subCat: "B",
        },
        {
          Question:
            "What are the key democratic (or political) institutions and processes established at the local level?",
          QuestionID: 2,
          subCat: "B",
        },
        {
          Question:
            "Has the country adopted a decentralization policy and framework?",
          QuestionID: 3,
          subCat: "B",
        },
        {
          Question:
            "If so, what type of decentralization system is it? Deconcentration, devolution and delegation, or a combination? What are its key characteristics and structures?",
          QuestionID: 4,
          subCat: "B",
        },
        {
          Question:
            "What powers and decision-making responsibilities does the institutional and policy framework for decentralization confer upon the local unit being assessed?",
          QuestionID: 5,
          subCat: "B",
        },
        {
          Question: "At what level of governance is public policy designed?",
          QuestionID: 6,
          subCat: "B",
        },
        {
          Question:
            " To what extent does the local unit have independence to generate and control its resources?",
          QuestionID: 7,
          subCat: "B",
        },
        {
          Question:
            "What vertical and horizontal accountability structures are formally in place?",
          QuestionID: 8,
          subCat: "B",
        },
        {
          Question:
            "Are there any traditional, customary or religious governance structures that play a role in the governance of the local unit?",
          QuestionID: 9,
          subCat: "B",
        },
        {
          Question:
            "What are influential external institutions or (illicit) power brokers within the local unit?",
          QuestionID: 10,
          subCat: "B",
        },
      ],
    },
    {
      subCategory: "Human safety and security",
      subCat: "C",
      romanNum: "III",
      overArching:
        "What is the general level of human safety and security in the local unit?",
      questions: [
        {
          Question:
            "To what extent have natural disasters, hunger, drought or disease occurred in the recent past?",
          QuestionID: 1,
          subCat: "C",
        },
        {
          Question:
            "Have there been any (armed) conflicts, and which actors were associated with it?",
          QuestionID: 2,
          subCat: "C",
        },
        {
          Question:
            "To what extent have these threats to human safety and security affected people’s lives and living conditions in the local unit?",
          QuestionID: 3,
          subCat: "C",
        },
        {
          Question:
            "What institutions/actors are expected to prevent and resolve these threats to human security and play a role in conflict prevention and resolution efforts?",
          QuestionID: 4,
          subCat: "C",
        },
        {
          Question:
            "How free is the local unit from the operation of organized criminal networks or gangs, illegal paramilitary forces, private armies or local warlords?",
          QuestionID: 5,
          subCat: "C",
        },
        {
          Question:
            "Are law enforcement agencies at the local level acting in a transparent way and are they duly supervised through democratic mechanisms?",
          QuestionID: 6,
          subCat: "C",
        },
        {
          Question:
            "In what way do the human safety and security challenges affect women and men differently?",
          QuestionID: 7,
          subCat: "C",
        },
        {
          Question:
            "To what extent do these challenges affect various groups of people within the local unit differently?",
          QuestionID: 8,
          subCat: "C",
        },
      ],
    },
  ],
  pillarsQuestions: [
    {
      subCategory: "Citizenship, equal rights and justice",
      subCat: 1,
      subsubCategories: [
        {
          subSubCategory: "Citizenship at the local level",
          subsubCat: "1.1",
          overArching:
            "What is the general level of human safety and security in the local unit?",
          questions: [
            {
              Question:
                "How inclusive is the local unit’s definition or interpretation of citizenship?",
              QuestionID: "1.1.1.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
            {
              Question:
                "To what extent are the concerns, interests and rights of all who live in the local unit equally considered?",
              QuestionID: "1.1.2.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
            {
              Question:
                "To what extent are different groups of people living in the local unit free from discrimination and exclusion, regardless of their nationality, age, residence, gender, sexuality, national or ethnic origin, skin colour, religion, political beliefs, language or any other status?",
              QuestionID: "1.1.3.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
            {
              Question:
                "To what extent are all people living in the local unit able to freely participate in public life without discrimination (e.g. those not registered at birth, undocumented migrants, stateless people, refugees, asylum seekers, internally displaced persons, etc.)?",
              QuestionID: "1.1.4.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
            {
              Question:
                "How far do women and men enjoy equality in citizenship and all opportunities and entitlements associated with it, such as ownership, parenthood, children’s citizenship, participation and representation in public affairs?",
              QuestionID: "1.1.5.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
            {
              Question:
                "To what extent are youth and the elderly living in the local unit equally included and accepted in all aspects of life?",
              QuestionID: "1.1.6.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
            {
              Question:
                "How far are different languages, cultures, religions and belief systems locally recognized and accepted?",
              QuestionID: "1.1.7.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
            {
              Question:
                "To what extent is the local unit free from identity-based conflict, societal divisions and/or polarization between different segments of society?",
              QuestionID: "1.1.8.",
              SubSubID: "1.1.",
              subCat: 1,
              subSubCategory: "Citizenship at the local level",
              overArching:
                "What is the general level of human safety and security in the local unit?",
            },
          ],
        },
        {
          subSubCategory: "Civil and political rights",
          subsubCat: "1.2",
          overArching:
            "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
          questions: [
            {
              Question:
                "To what extent are civil and political rights and freedoms equally guaranteed for all by the national constitution, laws and local regulations?",
              QuestionID: "1.2.1.",
              SubSubID: "1.2.",
              subCat: 1,
              subSubCategory: "Civil and political rights",
              overArching:
                "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "How equal and effective is the protection of people’s right to have opinions, speak, associate, assemble and organize?",
              QuestionID: "1.2.2.",
              SubSubID: "1.2.",
              subCat: 1,
              subSubCategory: "Civil and political rights",
              overArching:
                "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "How secure is the freedom for all to practice their own religion, language or culture?",
              QuestionID: "1.2.3.",
              SubSubID: "1.2.",
              subCat: 1,
              subSubCategory: "Civil and political rights",
              overArching:
                "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "To what extent can individuals effectively claim their civil and political rights and freedoms, and how free are they from societal norms or restrictions in doing so?",
              QuestionID: "1.2.4.",
              SubSubID: "1.2.",
              subCat: 1,
              subSubCategory: "Civil and political rights",
              overArching:
                "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "To what extent do women and men have equal opportunities to access and exercise these rights and freedoms?",
              QuestionID: "1.2.5.",
              SubSubID: "1.2.",
              subCat: 1,
              subSubCategory: "Civil and political rights",
              overArching:
                "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "How free from harassment and intimidation are those who exercise their rights and freedoms as a means of opposition to local authorities or the ruling elite?",
              QuestionID: "1.2.6.",
              SubSubID: "1.2.",
              subCat: 1,
              subSubCategory: "Civil and political rights",
              overArching:
                "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "To what extent is the local unit able to facilitate enjoyment of these rights and freedoms for marginalized or vulnerable groups, such as minorities, indigenous/tribal communities, migrant, displaced and refugee populations or other groups of people?",
              QuestionID: "1.2.7.",
              SubSubID: "1.2.",
              subCat: 1,
              subSubCategory: "Civil and political rights",
              overArching:
                "To what extent are civil and political rights and freedoms equally respected and upheld for every person living in the local unit?",
            },
          ],
        },
        {
          subSubCategory: "Economic, social, and cultural rights",
          subsubCat: "1.3",
          overArching:
            "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
          questions: [
            {
              Question:
                "To what extent are economic, social and cultural rights equally guaranteed for all by the national constitution, laws and local regulations?",
              QuestionID: "1.3.1.",
              SubSubID: "1.3.",
              subCat: 1,
              subSubCategory: "Economic, social, and cultural rights",
              overArching:
                "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "How far is access to education, work or social security available to all, without discrimination?",
              QuestionID: "1.3.2.",
              SubSubID: "1.3.",
              subCat: 1,
              subSubCategory: "Economic, social, and cultural rights",
              overArching:
                "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "To what extent are basic necessities in life such as adequate food, health care, housing and clean water guaranteed for all?",
              QuestionID: "1.3.3.",
              SubSubID: "1.3.",
              subCat: 1,
              subSubCategory: "Economic, social, and cultural rights",
              overArching:
                "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "To what extent can individuals effectively claim these basic necessities, and how free are they from societal norms or restrictions in doing so?",
              QuestionID: "1.3.4.",
              SubSubID: "1.3.",
              subCat: 1,
              subSubCategory: "Economic, social, and cultural rights",
              overArching:
                "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "To what extent do women and men have equal opportunities for accessing and exercising these rights and freedoms?",
              QuestionID: "1.3.5.",
              SubSubID: "1.3.",
              subCat: 1,
              subSubCategory: "Economic, social, and cultural rights",
              overArching:
                "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "How satisfied is the local population with the way local authorities deliver on these rights?",
              QuestionID: "1.3.6.",
              SubSubID: "1.3.",
              subCat: 1,
              subSubCategory: "Economic, social, and cultural rights",
              overArching:
                "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
            },
            {
              Question:
                "To what extent is the local unit able to facilitate enjoyment of these rights and freedoms for marginalized groups, minorities, indigenous/tribal communities, migrant, displaced and refugee populations or other groups of people?",
              QuestionID: "1.3.7.",
              SubSubID: "1.3.",
              subCat: 1,
              subSubCategory: "Economic, social, and cultural rights",
              overArching:
                "To what degree are economic, social and cultural rights equally respected and upheld for every person living in the local unit?",
            },
          ],
        },
        {
          subSubCategory: "Rule of law and access to justice",
          subsubCat: "1.4",
          overArching:
            "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
          questions: [
            {
              Question:
                "How far is the rule of law accepted and respected throughout the local unit?",
              QuestionID: "1.4.1.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                "To what extent are all local institutions and public officials subject to the law and to transparent rules in the performance of their functions?",
              QuestionID: "1.4.2.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                "How accessible is the justice system, including law enforcement agencies, courts and legal assistance, to all sections of society, men and women alike?",
              QuestionID: "1.4.3.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                "How equal and secure is individuals’ access to justice, to due process and to redress?",
              QuestionID: "1.4.4.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                "How impartial is the judicial system and to what extent is it trusted by the different sections of the local population?",
              QuestionID: "1.4.5.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                "How free are the courts and law enforcement agencies from manipulation, corruption and interference by political, private, criminal or illicit actors?",
              QuestionID: "1.4.6.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                "To what extent are traditional or customary justice systems operational in the local unit, and are they seen as alternative avenues for accessing justice?",
              QuestionID: "1.4.7.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                "To what extent do these institutions observe due rules of impartial and equitable treatment in the way they are functioning?",
              QuestionID: "1.4.8.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
            {
              Question:
                " How effective are formal and informal institutions and mechanisms for conflict prevention, management and resolution in the local unit?",
              QuestionID: "1.4.9.",
              SubSubID: "1.4.",
              subCat: 1,
              subSubCategory: "Rule of law and access to justice",
              overArching:
                "To what extent are the local government and citizens equally subject to and protected by the law, and able to access justice?",
            },
          ],
        },
      ],
    },
    {
      subCategory: "Representative and accountable institutions and processes",
      subCat: 2,
      subsubCategories: [
        {
          subSubCategory:
            "Elections and mechanisms of direct democracy at the local level",
          subsubCat: "2.1.",
          overArching:
            "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
          questions: [
            {
              Question:
                "How effective is the electoral system in granting the electorate a range of competitive choices, ensuring that their votes count equally and produce elected bodies that closely reflect their choices?",
              QuestionID: "2.1.1.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "To what extent does the electoral system produce an executive that is subordinate to the council?",
              QuestionID: "2.1.2.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "To what extent are referendums, recall, citizens’ and agenda initiatives and other types of consultations transparent and inclusive of topics and outcomes that reflect the views of all segments of society?",
              QuestionID: "2.1.3.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "To what extent do women and men fully and equally participate in electoral processes as voters and as candidates for elective office?",
              QuestionID: "2.1.4.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "How accessible are elections and election-related information to all eligible voters in the local unit, including people with disabilities, the illiterate, rural dwellers, etc.?",
              QuestionID: "2.1.5.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "To what degree do the local legislature and executive reflect the social composition of the electorate?",
              QuestionID: "2.1.6.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "How impartial and transparent are electoral procedures for voter, candidate and party registration?",
              QuestionID: "2.1.7.",
              SubSubID: "2.1.",
              subCat: 2,
              subCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "To what extent is equal access to media guaranteed for all political parties?",
              QuestionID: "2.1.8.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
            {
              Question:
                "How free from corruption, intimidation or outside interference are elections, and to what extent are disputes or allegations of election fraud peacefully addressed and resolved to the satisfaction of all concerned?",
              QuestionID: "2.1.9.",
              SubSubID: "2.1.",
              subCat: 2,
              subSubCategory:
                "Elections and mechanisms of direct democracy at the local level",
              overArching:
                "To what degree do elections and mechanisms of direct democracy give citizens control over the local government and its policies?",
            },
          ],
        },
        {
          subSubCategory: "Local legislature",
          subsubCat: "2.2.",
          overArching:
            "To what extent does the local legislature effectively fulfil its democratic mandate?",
          questions: [
            {
              Question:
                "How independent is the local legislature from the executive, and how free are its members to express their opinions and propose alternative policies?",
              QuestionID: "2.2.1.",
              SubSubID: "2.2.",
              subCat: 2,
              subSubCategory: "Local legislature",
              overArching:
                "To what extent does the local legislature effectively fulfil its democratic mandate?",
            },
            {
              Question:
                "How equal is the representation of women and men in the local legislature and other elected governing bodies?",
              QuestionID: "2.2.2.",
              SubSubID: "2.2.",
              subCat: 2,
              subSubCategory: "Local legislature",
              overArching:
                "To what extent does the local legislature effectively fulfil its democratic mandate?",
            },
            {
              Question:
                "To what extent does the composition of the legislature mirror the local population? Which groups are over/underrepresented and why?",
              QuestionID: "2.2.3.",
              SubSubID: "2.2.",
              subCat: 2,
              subSubCategory: "Local legislature",
              overArching:
                "To what extent does the local legislature effectively fulfil its democratic mandate?",
            },
            {
              Question:
                "How transparent and inclusive are council procedures for consulting the public, and how accessible are elected representatives to their constituents?\n",
              QuestionID: "2.2.4.",
              SubSubID: "2.2.",
              subCat: 2,
              subSubCategory: "Local legislature",
              overArching:
                "To what extent does the local legislature effectively fulfil its democratic mandate?",
            },
            {
              Question:
                "How extensive and effective are the powers of the local legislature to oversee the executive and hold it to account?",
              QuestionID: "2.2.5.",
              SubSubID: "2.2.",
              subCat: 2,
              subSubCategory: "Local legislature",
              overArching:
                "To what extent does the local legislature effectively fulfil its democratic mandate?",
            },
            {
              Question:
                "How transparent and rigorous are the legislature’s decision-making powers and procedures for budget approval and oversight of taxation and public expenditures?",
              QuestionID: "2.2.6.",
              SubSubID: "2.2.",
              subCat: 2,
              subSubCategory: "Local legislature",
              overArching:
                "To what extent does the local legislature effectively fulfil its democratic mandate?",
            },
            {
              Question:
                "How effective are mechanisms for protecting the local legislature and its members from external interference, corruption and other forms of inducement?",
              QuestionID: "2.2.7.",
              SubSubID: "2.2.",
              subCat: 2,
              subSubCategory: "Local legislature",
              overArching:
                "To what extent does the local legislature effectively fulfil its democratic mandate?",
            },
          ],
        },
        {
          subSubCategory: "Political parties",
          subsubCat: "2.3.",
          overArching:
            "To what extent do political parties effectively play their democratic role at the local level?",
          questions: [
            {
              Question:
                "How far does the party system enable political parties to effectively perform their roles in terms of campaigning, candidate nomination, member recruitment, training of politicians and influencing party plans, programmes and electoral manifestos?",
              QuestionID: "2.3.1.",
              SubSubID: "2.3.",
              subCat: 2,
              subSubCategory: "Political parties",
              overArching:
                "To what extent do political parties effectively play their democratic role at the local level?",
            },
            {
              Question:
                "To what extent do the political parties’ capacities, resources and internal procedures allow the parties to function effectively?",
              QuestionID: "2.3.2.",
              SubSubID: "2.3.",
              subCat: 2,
              subSubCategory: "Political parties",
              overArching:
                "To what extent do political parties effectively play their democratic role at the local level?",
            },
            {
              Question:
                "How involved and influential are party members in party policy development and candidate selection?",
              QuestionID: "2.3.3.",
              SubSubID: "2.3.",
              subCat: 2,
              subSubCategory: "Political parties",
              overArching:
                "To what extent do political parties effectively play their democratic role at the local level?",
            },
            {
              Question:
                "How balanced is the number of women and men within the party and party leadership, and to what extent do women and men participate on equal footing?",
              QuestionID: "2.3.4.",
              SubSubID: "2.3.",
              subCat: 2,
              subSubCategory: "Political parties",
              overArching:
                "To what extent do political parties effectively play their democratic role at the local level?",
            },
            {
              Question:
                "To what extent do political parties cross ethnic, religious and linguistic divisions and offer equal opportunities to all to become party members or candidates?",
              QuestionID: "2.3.5.",
              SubSubID: "2.3.",
              subCat: 2,
              subSubCategory: "Political parties",
              overArching:
                "To what extent do political parties effectively play their democratic role at the local level?",
            },
            {
              Question:
                "To what degree do parties and party leaders receive public funding and/or other financial contributions? How free are parties from crime and corruption?",
              QuestionID: "2.3.6.",
              SubSubID: "2.3.",
              subCat: 2,
              subSubCategory: "Political parties",
              overArching:
                "To what extent do political parties effectively play their democratic role at the local level?",
            },
            {
              Question:
                "How representative and trusted are political parties and politicians at the local level?",
              QuestionID: "2.3.7.",
              SubSubID: "2.3.",
              subCat: 2,
              subSubCategory: "Political parties",
              overArching:
                "To what extent do political parties effectively play their democratic role at the local level?",
            },
          ],
        },
        {
          subSubCategory: "Local executive/governing bodies",
          subsubCat: "2.4.",
          overArching:
            "How accountable and responsive are local executive bodies in serving the local population?",
          questions: [
            {
              Question:
                "What is the extent of the local executive’s authority and control over matters that are important to people’s lives and how well is it trusted, informed, organized and resourced to do so?",
              QuestionID: "2.4.1.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "Through what mechanisms do local officials occupy their positions? Election or appointment? Based on merits or connections?",
              QuestionID: "2.4.2.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "To what degree is the local government, including armed forces, police and security agencies, subject to oversight by the legislature, the media and watchdog groups?",
              QuestionID: "2.4.3.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "To what extent does the executive make government information available and accessible to all sections of the local population?",
              QuestionID: "2.4.4.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "How open and transparent are processes for government agenda-setting, policy-making, policy implementation, monitoring and evaluation?",
              QuestionID: "2.4.5.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "How inclusive and systematic are mechanisms for citizen participation and public consultation?",
              QuestionID: "2.4.6.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "How accessible and reliable are public services for all those who need them?",
              QuestionID: "2.4.7.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "How accountable is the local government in delivering these services?",
              QuestionID: "2.4.8.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
            {
              Question:
                "How balanced is the number of women and men working for the local government and to what extent are government polices gender sensitive?",
              QuestionID: "2.4.9.",
              SubSubID: "2.4.",
              subCat: 2,
              subSubCategory: "Local executive/governing bodies",
              overArching:
                "How accountable and responsive are local executive bodies in serving the local population?",
            },
          ],
        },
        {
          subSubCategory: "Customary and traditional institutions",
          subsubCat: "2.5.",
          overArching:
            "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
          questions: [
            {
              Question:
                "How far do customary, traditional and/or religious institutions and systems of governance play a role in the public affairs of the local unit?",
              QuestionID: "2.5.1.",
              SubSubID: "2.5.",
              subCat: 2,
              subSubCategory: "Customary and traditional institutions",
              overArching:
                "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
            },
            {
              Question:
                "How transparent and accepted is their institutional mandate, and to what extent do they have the trust and confidence of the local population?",
              QuestionID: "2.5.2.",
              SubSubID: "2.5.",
              subCat: 2,
              subSubCategory: "Customary and traditional institutions",
              overArching:
                "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
            },
            {
              Question:
                "How influential are these institution in relation to the local executive, legislature and judiciary?",
              QuestionID: "2.5.3.",
              SubSubID: "2.5.",
              subCat: 2,
              subSubCategory: "Customary and traditional institutions",
              overArching:
                "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
            },
            {
              Question:
                "To what extent do these institutions contribute to or undermine the delivery of services in the local unit?",
              QuestionID: "2.5.4.",
              SubSubID: "2.5.",
              subCat: 2,
              subSubCategory: "Customary and traditional institutions",
              overArching:
                "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
            },
            {
              Question:
                "To what degree do the decision-making processes and operations of these institutions foster gender equality and diversity in the local unit?",
              QuestionID: "2.5.5.",
              SubSubID: "2.5.",
              subCat: 2,
              subSubCategory: "Customary and traditional institutions",
              overArching:
                "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
            },
            {
              Question:
                "How far does the leadership and composition of these institutions mirror the local unit population in terms of gender, age, religion, ethnicity, class, etc.?",
              QuestionID: "2.5.6.",
              SubSubID: "2.5.",
              subCat: 2,
              subSubCategory: "Customary and traditional institutions",
              overArching:
                "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
            },
            {
              Question:
                "To what extent is there harmony between modern and traditional institutions of governance and how far are these institutions considered a source of stability?",
              QuestionID: "2.5.7.",
              SubSubID: "2.5.",
              subCat: 2,
              subSubCategory: "Customary and traditional institutions",
              overArching:
                "To what degree do customary and traditional institutions and systems of governance influence the quality and functioning of democracy in the local unit?",
            },
          ],
        },
      ],
    },
    {
      subCategory: "Citizen initiative and participation",
      subCat: 3,
      subsubCategories: [
        {
          subSubCategory: "Active citizen engagement",
          subsubCat: "3.1.",
          overArching:
            "To what extent is there full, active and regular citizen engagement in public life at the local level?",
          questions: [
            {
              Question:
                "To what extent do citizens undertake individual and collective actions to address issues of public concern?",
              QuestionID: "3.1.1.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "To what degree does the local population organize itself through social and political movements, civil society organizations and/or civic associations?",
              QuestionID: "3.1.2.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "To what extent do popular public figures, civic leaders and/or activists engage politically?",
              QuestionID: "3.1.3.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "How often are public spaces such as parks, public meeting venues or online platforms being used for public deliberation and action, and to what degree do rules, such as those governing public gatherings, protests, demonstrations, etc., stand in the way of these initiatives?",
              QuestionID: "3.1.4.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "To what extent does the local population express a need for and interest in citizen deliberation and participation in issues that affect their quality of life?",
              QuestionID: "3.1.5.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "How free from intimidation and oppression are those who claim their right to freely speak and express views, organize, associate and mobilize themselves?",
              QuestionID: "3.1.6.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "How pluralistic are forums for citizen participation and deliberation, and what are the typical roles of women and men in these forums?",
              QuestionID: "3.1.7.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "How effective are citizen initiatives in addressing issues of concern and for holding decision-makers to account, e.g. for service delivery?",
              QuestionID: "3.1.8.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
            {
              Question:
                "To what extent do citizen initiatives, actions and/or protest give rise to tension or conflict, and are these conflicts mitigated and resolved peacefully?",
              QuestionID: "3.1.9.",
              SubSubID: "3.1.",
              subCat: 3,
              subSubCategory: "Active citizen engagement",
              overArching:
                "To what extent is there full, active and regular citizen engagement in public life at the local level?",
            },
          ],
        },
        {
          subSubCategory: "Media",
          subsubCat: "3.2.",
          overArching:
            "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
          questions: [
            {
              Question:
                "How safe and enabling is the environment for the media, including journalists, media workers and associated personnel, to operate freely?",
              QuestionID: "3.2.1.",
              SubSubID: "3.2.",
              subCat: 3,
              subSubCategory: "Media",
              overArching:
                "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
            },
            {
              Question:
                "How plural are media ownership, outlets and platforms at the local level, and how independent are local media from national media?",
              QuestionID: "3.2.2.",
              SubSubID: "3.2.",
              subCat: 3,
              subSubCategory: "Media",
              overArching:
                "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
            },
            {
              Question:
                "How independent and impartial are the media in the local unit and how free from capture by political, business or other interests?",
              QuestionID: "3.2.3.",
              SubSubID: "3.2.",
              subCat: 3,
              subSubCategory: "Media",
              overArching:
                "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
            },
            {
              Question:
                "How effective are the media in scrutinizing and investigating local government and other power holders on issues that matter to the local population?",
              QuestionID: "3.2.4.",
              SubSubID: "3.2.",
              subCat: 3,
              subSubCategory: "Media",
              overArching:
                "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
            },
            {
              Question:
                "How accessible are the media for male and female opinion leaders, and to what extent do the media play a role in combating or perpetuating gender-based stereotypes?",
              QuestionID: "3.2.5.",
              SubSubID: "3.2.",
              subCat: 3,
              subSubCategory: "Media",
              overArching:
                "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
            },
            {
              Question:
                "How accessible are media outlets and the Internet to everyone living within the local unit and how does this improve or affect equal access to information?",
              QuestionID: "3.2.6.",
              SubSubID: "3.2.",
              subCat: 3,
              subSubCategory: "Media",
              overArching:
                "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
            },
            {
              Question:
                "How representative are media of different opinions and how inclusive of the views of the entire local population, including marginalized or minority groups?",
              QuestionID: "3.2.7.",
              SubSubID: "3.2.",
              subCat: 3,
              subSubCategory: "Media",
              overArching:
                "To what degree is the media effectively playing its role in sustaining democratic values in the local unit?",
            },
          ],
        },
      ],
    },
  ],
};
